import { Source, Label, ChartTitle, ChartDescription } from 'components/styles'
import styled, { useTheme } from 'styled-components'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import SVG from 'react-inlinesvg'
import svgSourceVd from '../../images/people-desktop-vd.svg'
import svgSourceMobileVd from '../../images/people-mobile-vd.svg'
import svgSourceGe from '../../images/people-desktop-ge.svg'
import svgSourceMobileGe from '../../images/people-mobile-ge.svg'
import svgArrow from '../../images/arrow.svg'
import { useEffect, useState } from 'react'

const People = () => {
  const theme = useTheme()
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
    }

    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])
  
  const labelPositionData:any = {
    '24heures': {
      'ch': isMobile ? {top: '60%', left: '30%'} : {top: '60%', left: '20%'},
      'canton': isMobile ? {top: '32%', left: '45%'} : {top: '50%', left: '65%'},
      'legend': isMobile ? {top: '6%', left: '20px'} : {top: '13%', left: '20px'},
      'you': isMobile ? {top: '-5px', left: '61%'} : {top: '2%', left: '61%'}
    },
    'tdg': {
      'ch': isMobile ? {top: '60%', left: '30%'} : {top: '60%', left: '20%'},
      'canton': isMobile ? {top: '27%', left: '35%'} : {top: '40%', left: '65%'},
      'legend': isMobile ? {top: '6%', right: '20px', textAlign: 'right'} : {top: '13%', left: '20px'},
      'you': isMobile ? {top: '-5px', left: '54%'} : {top: '2%', left: '61%'}
    }
  }

  const labelPosition = labelPositionData[theme.tenant] || labelPositionData['tdg']

  return (
    <Container>
      <TextWidth>
        <ChartTitle>Le poids d'un vote</ChartTitle>
        <ChartDescription>
          Que représentait une voix lors des dernières élections du Conseil
          national, en 2019.
        </ChartDescription>
      </TextWidth>
      <Content>
        <Label style={labelPosition.ch}>
          <b>{(2462581).toLocaleString('fr-CH')}</b>
          <br />
          votants suisses
        </Label>

        <Label
          style={labelPosition.canton}
        >
          <StyledArrow
            style={{
              position: 'absolute',
              top: '50%',
              left: 0,
              transform: 'scale(-1, -1) rotate(30deg) translate(120%, 0)',
            }}
            src={svgArrow}
            width={'40px'}
          />
          {theme.tenant === '24heures' ? (
            <>
              <b>{(187644).toLocaleString('fr-CH')}</b>
              <br />
              votants vaudois
            </>
          ) : (
            <>
              <b>{(102496).toLocaleString('fr-CH')}</b>
              <br />
              votants genevois
            </>
          )}
        </Label>

        <Label style={labelPosition.you}>
        <StyledArrow
          style={{
            position: 'absolute',
            top: -4,
            left: 0,
            transform: 'scaleX(-1) rotate(10deg) translate(120%, 0)',
          }}
          src={svgArrow}
          width={'40px'}
        />
          <b>Votre voix</b>
        </Label>
        <Label style={labelPosition.legend}>
          <LegendUnit /> = 100 votants
        </Label>
        <StyledSvg
          src={
            isMobile
              ? theme.tenant === '24heures'
                ? svgSourceMobileVd
                : svgSourceMobileGe
              : theme.tenant === '24heures'
              ? svgSourceVd
              : svgSourceGe
          }
          width={'100%'}
          title='React'
        />
      </Content>
      <TextWidth>
        <Source>Source: Chancellerie fédérale</Source>
      </TextWidth>
    </Container>
  )
}

// @ts-ignore
const StyledSvg = styled(SVG)`
  g[id^='grey'] {
    rect,
    polygon {
      fill: ${({ theme }) => `rgb(${theme.grayColorMedium})`};
    }
  }

  g[id^='color'] {
    rect,
    polygon {
      fill: ${({ theme }) => `rgb(${theme.colorMain})`};
    }
  }

  g[id^='grid'] {
    line {
      stroke: ${({ theme }) => `rgb(${theme.siteBackground})`};
    }
  }

  g[id^='zoom'] {
    rect,
    polygon,
    polyline {
      fill: ${({ theme }) => `rgb(${theme.colorMain})`};
    }
  }
`

// @ts-ignore
const StyledArrow = styled(SVG)`
  path {
    opacity: 1;
    fill: ${({ theme }) => `rgb(${theme.colorBlueDark})`};
  }
`

const LegendUnit = styled.div`
  width: 10px;
  height: 10px;
  background: ${({ theme }) => `rgb(${theme.grayColorMedium})`};
  display: inline-block;
`

const Container = styled.div`
  margin-top: 40px;
  margin-bottom: 90px;
`

const Content = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  position: relative;
  padding: 0 20px;
`

const Image = styled.img`
  width: 100%;
  display: block;
`

export default People
